import {MutationTree} from 'vuex'
import {ITicketState} from './ticket-state.store';
import {
  TICKET_SET_TICKETS, TICKET_LOADING,
  TICKET_UPDATE_TICKETS,
  TICKET_SET_TICKETS_SIDEBAR,
  TICKET_SET_TICKET_SIDEBAR,
  TICKET_SET_TICKET_ACTIONS,
  TICKET_SET_APPOINTMENT_BY_FIELD,
  TICKET_ASSIGN_ME,
  TICKET_SET_PARAMETER,
  TICKET_ACTION_RECEIVE_MESSAGE,
  TICKET_ACTION_LOADING,
  TICKET_ACTION_ATTACHMENTS,
  TICKET_INIT,
  TICKET_SET_TICKETS_PARAMETER_SIDEBAR,
  TICKET_SET_TICKETS_PARAMETER,
  TICKET_CLEAR_ATTACHMENTS,
  TICKET_UPDATE_CURRENT_STATE,
  TICKET_ADD_SINGLE_ITEM,
  TICKET_SET_TICKET_STATE,
  TICKET_SET_TICKET_IN_LIST_REALTIME,
  TICKET_RESET_TICKETS,
  TICKET_SET_TICKET_APPOINTMENT,
  // TICKET_GET_CHARACTER_PROBLEMS,
  TICKET_SET_CHARACTER_PROBLEMS,
  TICKET_GET_CLOSURE_REASON_LOADING,
  TICKET_GET_CLOSURE_REASON,
  TICKET_GET_REASONS_LOADING,
  TICKET_GET_REASONS,
  TICKET_SET_TICKET_CHANNEL,
  TICKET_SET_TICKET_AFTER_JOIN,
  // TICKET_REMOVED_PARTICIPANT,
  TICKET_JOIN_CHANNEL,
  TICKET_QUIT_CHANNEL,
  TICKET_REMOVE_PARTICIPANTS,
  TICKET_RESET_CURRENT_CHANNEL,
  TICKET_GET_APPOINTMENTS,
  TICKET_GET_TICKET_INDEPENDENT_CONTRACTORS,
  TICKET_UPDATE_CURRENT_CHANNEL_ACTIONS,
  TICKET_ACTION_DELETE_MESSAGE,
  TICKET_ACTION_EDIT_MESSAGE,
  TICKET_CLOSE_CURRENT_CHANNEL,
  TICKET_REMOVE_IC,
  TICKET_CLOSE_CHANNEL,
  TICKET_REOPEN_CHANNEL,
  TICKET_EDIT,
  TICKET_SET_EXTERNAL_APARTMENT,
  TICKET_SOCKET_EDIT,
  TICKET_SET_LOADER_STATE,
  TICKET_SET_TICKET_PRIORITY_LEVEL,
  TICKET_SET_TICKET_SUBSTATUS,
  TICKET_INCREASE_UNREAD_MESSAGE,
  TICKET_INIT_UNREAD_MESSAGE,
  TICKET_SET_TICKET_PROBLEM_TYPE,
  TICKET_SET_EQUIPMENT, TICKET_RESET_FILTERS
} from './ticket-types.store';
import {ActivityStatus, StateTypes} from '../../common/enums';
import {ITicketListingViewModel, ITicketChannel, ITicketParameter, ITicket, TicketParameter} from '../../models/ticket';
import {IUserDetails} from '../../models/user';
import {Pagination} from '../../models/generic';
import {IAppointmentListingViewModel} from '../../models/appointment';

export const mutations: MutationTree<ITicketState> = {
  [TICKET_LOADING]: (state: ITicketState, activityStatus: ActivityStatus) => {
    state.activityStatus = activityStatus
  },
  [TICKET_ACTION_LOADING]: (state: ITicketState, activityStatus: ActivityStatus) => {
    state.actionLoading = activityStatus
  },
  [TICKET_SET_TICKETS]: (state: ITicketState, payload: {
    activityStatus: ActivityStatus,
    merge?: boolean,
    tickets: any[],
    pagination?: any
  }) => {
    if (payload.merge === false) {
      state.tickets = payload.tickets;
    } else {
      const tickets = state.tickets || [];
      const uniqueTickets = payload.tickets.filter((item, index) => {
        return tickets.findIndex(t => t.id === item.id) === -1
      });
      state.tickets = tickets.concat(uniqueTickets)
    }

    state.activityStatus = payload.activityStatus;

    if (payload.pagination) {
      state.pagination = payload.pagination;
    }

  },
  [TICKET_UPDATE_TICKETS] : (state: ITicketState, payload: {
    ticketId: number,
    data: any
  }) => {
    state.tickets= state.tickets.map((ticket: ITicketListingViewModel ,index:number)=>{
      if(ticket.id === payload.ticketId ){
        ticket = {
          ...ticket,
          ...payload.data,
          updatedAt: Date.now()
        }
      }
      return ticket
    })
  },
  [TICKET_RESET_TICKETS]: (state: ITicketState, payload: {
    activityStatus: ActivityStatus,
    merge?: boolean,
    tickets: any[],
    pagination?: any
  }) => {
    // state.ticketParameter = new TicketParameter();
    state.pagination = new Pagination({total: 0, limit: 10, skip: 0});
    state.tickets = [];
    state.activityStatus = ActivityStatus.NoActivity;
  },
  [TICKET_RESET_FILTERS]: (state: ITicketState, payload: {
    activityStatus: ActivityStatus,
    merge?: boolean,
    tickets: any[],
    pagination?: any
  }) => {
    state.ticketParameter = new TicketParameter();
    state.ticketParameter = {
      ...state.ticketParameter,
      state: [StateTypes.Open, StateTypes.InProgress, StateTypes.ReOpen],
      visibility: 'self'
    }
    state.pagination = new Pagination({total: 0, limit: 10, skip: 0});
    state.tickets = [];
    state.activityStatus = ActivityStatus.NoActivity;
  },
  [TICKET_SET_TICKETS_SIDEBAR]: (state: ITicketState, payload: { tickets: ITicketListingViewModel[], ticketId: number }) => {
    state.sideBarTickets = payload.tickets;
    if (payload.ticketId) {
      state.currentTicket = payload.tickets.find(t => t.id === payload.ticketId);
    }
  },
  [TICKET_SET_TICKET_SIDEBAR]: (state: ITicketState, ticket: ITicketListingViewModel) => {
    state.currentTicket = ticket;
    const indexOfCurrentTicket: number = (state.tickets || []).findIndex(x => x.id === ticket.id);
    if (indexOfCurrentTicket > -1) {
      state.tickets[indexOfCurrentTicket].close_ticket_reason_name = ticket.close_ticket_reason_name;
      state.tickets[indexOfCurrentTicket].close_ticket_reason_desc = ticket.close_ticket_reason_desc;
    }
  },
  [TICKET_SET_TICKET_ACTIONS]: (state: ITicketState, payload: {
    activityStatus: ActivityStatus, currentChannel: ITicketChannel,
    currentChannelId: number, currentTicketId: number,
    ownerId: number
  }) => {
    state.activityStatus = payload.activityStatus;
    state.currentChannel = Object.assign({}, state.currentChannel, payload.currentChannel);
    state.currentChannelId = payload.currentChannelId;
    state.currentTicketId = payload.currentTicketId;

    const ticketIndex: number = (state.tickets || []).findIndex(x => x.id === payload.currentTicketId);
    if (ticketIndex > -1) {
      if (state.tickets[ticketIndex].nb_message_unread > 0)
        state.tickets[ticketIndex].nb_message_unread = 0;
    }
  },
  [TICKET_SET_APPOINTMENT_BY_FIELD]: (state: ITicketState,
                                      payload: { [key: string]: any }) => {
    state.ticket = Object.assign({}, state.ticket, {...payload});
  },
  [TICKET_INIT]: (state: ITicketState, payload: ITicket) => {
    state.ticket = payload;
  },
  [TICKET_EDIT]: (state: ITicketState,payload: any) => {
    state.currentTicket= {
      ...state.currentTicket,
      ...payload,
      ...payload.fk_ticket_character_problem && { fk_ticket_character_problem_name: state.characterProblems.level_1.find(pb=> pb.id === payload.fk_ticket_character_problem ).name },
      ...payload.fk_character_problem_level_2 && { fk_character_problem_level_2_name: state.characterProblems.level_2.find(pb=> pb.id === payload.fk_character_problem_level_2 ).name },
      substatus: state.ticketSubstatus.find(tss=>tss.id===payload.fk_ticket_substatus),
      ticket_priority: state.ticketPriorityLevels.find(tp=>tp.id===payload.fk_ticket_priority)
    }

  },
  [TICKET_SOCKET_EDIT]: (state: ITicketState, data: any ) => {
    state.message= data
  },
  [TICKET_ASSIGN_ME]: (state: ITicketState, currentManagerId: number | any) => {
    state.ticket.managers_assigned.push(currentManagerId);
  },
  [TICKET_SET_PARAMETER]: (state: ITicketState, parameter: ITicketParameter) => {
    state.ticketParameter = parameter;
  },
  [TICKET_ACTION_EDIT_MESSAGE]: (state: ITicketState, message: any) => {
    state.message = message
  },
  [TICKET_ACTION_RECEIVE_MESSAGE]: (state: ITicketState, message: any) => {
    state.message = message

    if (state.currentTicket && state.currentChannel.id > 0 && state.currentChannel.id !== message.fk_action_channel) {
      const channelIndex: number = state.currentTicket.channels.findIndex(x => x.id === message.fk_action_channel)
      if (channelIndex > -1) {
        const {participants} = state.currentTicket.channels[channelIndex];
        const participantIndex: number = (participants || []).findIndex(x => x.fk_actor_entity === message.ownerId);
        if (participantIndex > -1) {
          participants[participantIndex].participant_channel.nb_message_unread++;
        }
      }
    }
  },
  [TICKET_INCREASE_UNREAD_MESSAGE] : (state: ITicketState, ticket_id) => {
    /**
     *  @description handle tickets unread messages (notifications)
     */
      const ticketIndex = (state.tickets || []).findIndex(x => x.id === ticket_id);
      if (ticketIndex > -1)
        state.tickets[ticketIndex].nb_message_unread++

      const ticketSidebarIndex = (state.sideBarTickets || []).findIndex(x => x.id === ticket_id)
      if (ticketSidebarIndex > -1)
        state.sideBarTickets[ticketSidebarIndex].nb_message_unread++
  },
  [TICKET_INIT_UNREAD_MESSAGE] : (state: ITicketState) => {
    state.tickets= (state.tickets || []).map(ticket=>  ({ ...ticket, nb_message_unread: 0 }) )
    state.sideBarTickets= (state.sideBarTickets || []).map(ticket => ({ ...ticket, nb_message_unread: 0 }))

    state.currentTicket= {
        ...state.currentTicket,
        channels: (state.currentTicket.channels || []).map(channel=>{
                          return {
                            ...channel,
                            participants: channel.participants.map(participant=>{
                              participant.participant_channel.nb_message_unread= 0
                              return participant
                            })
                          }
                      })
    }
  },
  [TICKET_ACTION_DELETE_MESSAGE]: (state: ITicketState, message: any) => {
    state.message = message
    if (state.currentTicket && state.currentChannel.id > 0 && state.currentChannel.id !== message.fk_action_channel) {
      const channelIndex: number = state.currentTicket.channels.findIndex(x => x.id === message.fk_action_channel)
      if (channelIndex > -1) {
        const {participants} = state.currentTicket.channels[channelIndex];
        const participantIndex: number = participants.findIndex(x => x.fk_actor_entity === message.ownerId);
        if (participantIndex > -1) {
          participants[participantIndex].participant_channel.nb_message_unread++;
          if (participants[participantIndex].participant_channel.nb_message_unread > 0)
            participants[participantIndex].participant_channel.nb_message_unread--;
        }
      }
    }
    const ticketIndex = (state.tickets || []).findIndex(x => x.id === message.ticket_id);
    if (ticketIndex > -1) {
      if (state.tickets[ticketIndex].nb_message_unread > 0)
        state.tickets[ticketIndex].nb_message_unread--
    }
    const ticketSidebarIndex = (state.sideBarTickets || []).findIndex(x => x.id === message.ticket_id)
    if (ticketSidebarIndex > -1) {
      if (state.sideBarTickets[ticketSidebarIndex].nb_message_unread > 0)
        state.sideBarTickets[ticketSidebarIndex].nb_message_unread--
    }
  },
  [TICKET_ACTION_ATTACHMENTS]: (state: ITicketState, attachments: any[]) => {
    state.attachmentsInQueue = attachments;
  },
  [TICKET_CLEAR_ATTACHMENTS]: (state: ITicketState, id: string) => {
    state.attachmentsInQueue = state.attachmentsInQueue.filter(att => att.fakeId !== id);
  },
  [TICKET_SET_TICKETS_PARAMETER]: (state: ITicketState, searchParamter: ITicketParameter) => {
    state.ticketParameter = Object.assign({}, state.ticketParameter, searchParamter);
  },
  [TICKET_SET_TICKETS_PARAMETER_SIDEBAR]: (state: ITicketState, searchParamter: ITicketParameter) => {
    state.ticketSidebarParameter = searchParamter;
  },
  [TICKET_UPDATE_CURRENT_STATE]: (state: ITicketState, ticketState: string) => {
    state.currentTicket.state = ticketState;
  },
  [TICKET_SET_TICKET_STATE]: (state: ITicketState, payload: { action_type: string, ticket_id: number }) => {
    if (state.currentTicket.id === payload.ticket_id) {
      state.currentTicket.state = payload.action_type;
    }
    const ticketIndex = (state.tickets || []).findIndex(x => x.id === payload.ticket_id);
    if (ticketIndex !== -1) {
      state.tickets[ticketIndex].state = payload.action_type;
    }
  },
  [TICKET_SET_TICKET_IN_LIST_REALTIME]: (state: ITicketState, payload: { concern_actor: { entity: IUserDetails }, ticket_id: number }) => {
    const ticketIndex = (state.tickets || []).findIndex(x => x.id === payload.ticket_id);
    if (ticketIndex !== -1) {
      state.tickets[ticketIndex].independents_contractors_mandate.unshift(payload.concern_actor.entity);
    }
  },
  [TICKET_ADD_SINGLE_ITEM]: (state: ITicketState,
                             ticket: ITicketListingViewModel) => {
    const notExisted: boolean = (state.tickets || []).filter(x => x.id === ticket.id).length === 0;
    if (notExisted) {
      if (state.tickets === null || state.tickets.length === 0) {
        state.tickets = [ticket];
      } else {
        state.tickets.unshift(ticket);
      }
    }
  }
  , [TICKET_SET_TICKET_APPOINTMENT]: (state: ITicketState, message) => {
    if (state.tickets === null) return;
    const ticketIndex: number = state.tickets.findIndex(x => x.id === message.ticket_id);
    if (ticketIndex > -1) {
      state.tickets[ticketIndex].appointments[0].actions = [{
        action_type: message.action_type,
        appointment_actions: message.appointment_actions,
        id: message.id
      }]
    }
  },
  [TICKET_SET_CHARACTER_PROBLEMS]: (state: ITicketState, data) => {
    state.characterProblems = data;
  },
  [TICKET_SET_EQUIPMENT]: (state: ITicketState, data) => {
    state.equipments = data;
  },
  [TICKET_SET_EXTERNAL_APARTMENT] : (state:ITicketState, force_external_apartment :boolean | undefined ) => {
    state.ticket= {
      ...state.ticket,
      force_external_apartment
    }
  },
  [TICKET_GET_CLOSURE_REASON_LOADING]: (state: ITicketState, activityStatus: ActivityStatus) => {
    state.ticketClosureReasonsActivityStatus = activityStatus;
  },
  [TICKET_GET_REASONS_LOADING]: (state: ITicketState, activityStatus: ActivityStatus) => {
    state.ticketReasonsActivityStatus = activityStatus;
  },
  [TICKET_GET_CLOSURE_REASON]: (state: ITicketState, data: any[]) => {
    state.ticketClosureReasons = data;
    state.ticketClosureReasonsActivityStatus = ActivityStatus.Loaded;
  },
  [TICKET_GET_REASONS]: (state: ITicketState, data: any[]) => {
    state.ticketReasons = data;
    state.ticketReasonsActivityStatus = ActivityStatus.Loaded;
  },
  [TICKET_SET_TICKET_CHANNEL]: (state: ITicketState, ticket: ITicketListingViewModel) => {
    if (state.currentTicket!.id === ticket.id) {
      state.currentTicket.channels = ticket.channels
    }
  },
  [TICKET_SET_TICKET_AFTER_JOIN]: (state: ITicketState, data) => {

    const canAdd: boolean = state.currentChannel.participants.filter(x => x['fk_actor_entity'] === data.actor.fk_actor_entity).length === 0;
    if (canAdd) {
      state.currentChannel.participants.push(data.actor)
    }
  },
  [TICKET_JOIN_CHANNEL]: (state: ITicketState, data) => {

    const isNotExisted: boolean = state.currentChannel.participants.filter(x => x.fk_actor_entity === data.fk_actor_entity).length === 0;
    if (isNotExisted) {
      state.currentChannel.participants.push(data.actor);
    }
  },
  [TICKET_REMOVE_PARTICIPANTS]: (state: ITicketState, data) => {
    state.currentChannel.participants = state.currentChannel.participants.filter(x => x.fk_actor_entity !== data.data[0].id)
  },
  [TICKET_CLOSE_CURRENT_CHANNEL]: (state: ITicketState, data) => {
    state.currentChannel.state = 'close'
  },
  [TICKET_QUIT_CHANNEL]: (state: ITicketState, data) => {

  },
  [TICKET_REMOVE_IC]: (state: ITicketState, data) => {
    state.message = data
    if (state.currentTicket.id === data.ticket_id) {
      if (state.currentChannel.id === data.fk_action_channel) {
        state.currentChannel.participants = state.currentChannel.participants.filter(x => x.fk_actor_entity !== data.concern_actor.fk_actor_entity)
      }
    }
  },
  [TICKET_CLOSE_CHANNEL]: (state: ITicketState, data) => {
    state.message = data
    if (state.currentTicket.id === data.ticket_id) {
      if (state.currentChannel.id === data.fk_action_channel) {
        state.currentChannel.state = 'close'
      }
    }
  },
  [TICKET_REOPEN_CHANNEL]: (state: ITicketState, data) => {
    state.message = data
    if (state.currentTicket.id === data.ticket_id) {
      if (state.currentChannel.id === data.fk_action_channel) {
        state.currentChannel.state = 'open'
      }
    }
  },
  [TICKET_RESET_CURRENT_CHANNEL]: (state: ITicketState) => {
    state.currentChannel = {
      actions: []
    }
  },
  [TICKET_UPDATE_CURRENT_CHANNEL_ACTIONS]: (state: ITicketState, data) => {
    state.currentChannel.actions = data
  },
  [TICKET_GET_APPOINTMENTS]: (state: ITicketState, appointments: IAppointmentListingViewModel[]) => {
    state.appointments = appointments
  },
  [TICKET_GET_TICKET_INDEPENDENT_CONTRACTORS]: (state: ITicketState, ticket) => {
    state.ticketIndependentContractors = ticket.independents_contractors_mandate;
  },
  [TICKET_SET_LOADER_STATE] : (state: ITicketState, payload: { key: any , value: boolean } ) => {

    const map: Map<string,boolean> = typeof payload.key === 'string' ?
                              new Map([ [payload.key ,payload.value] ]) :
                                    new Map(payload.key.map( (key: string) => [key,payload.value]))

    state.loaders= new Map([
      ...state.loaders,
      ...map
    ])
  },
  [TICKET_SET_TICKET_PRIORITY_LEVEL]: (state: ITicketState, data) => {
    state.ticketPriorityLevels = data;
  },
  [TICKET_SET_TICKET_SUBSTATUS]: (state: ITicketState, data) => {
    state.ticketSubstatus = data;
  },
  [TICKET_SET_TICKET_PROBLEM_TYPE]: (state: ITicketState, data) => {
    state.ticketProblemType = data;
  }
}



// WEBPACK FOOTER //
// ./src/store/ticket/ticket-mutations.store.ts